export default "__VITE_ASSET__8d2fd895__"